export default __webpack_public_path__ + "static/media/s4_title-autumns.21aa8a89.png";